import chooseNextProperId from 'helpers/chooseNextProperId'
import { doorControllerDefaults } from 'helpers/accessControl/defaults'
import wireDefaults from 'helpers/wires/defaults'
import { ACCESS_HEADING_ROTATION_DEGREE } from 'helpers/globals'

export default function addExpansionController(state, action) {
  const { location, parentId, model } = action
  const { entities: { doorControllers: { allIds, byId }, wires } } = state
  const id = chooseNextProperId(allIds)

  const parentController = byId[parentId]

  if (!parentController) return state

  const doorController = Object.assign({}, doorControllerDefaults, {
    name: `Expansion Controller ${parentController.expansionIds.length + 1}`,
    isExpansion: true,
    location,
    id,
    parentId,
    model
  })

  const wiresById = { ...wires.byId }
  let newWireIds = [...wires.allIds]

  if (model.connection !== 'Ethernet') {
    const wireId = chooseNextProperId(wires.allIds)
    const wire = Object.assign({}, wireDefaults, {
      location: [location, parentController.location],
      strokeColor: doorController.color,
      start: { id, type: 'doorController' },
      end: { id: parentId, type: 'doorController' },
      id: wireId
    })

    wiresById[wireId] = wire
    newWireIds = newWireIds.concat(wireId)
  }

  return Object.assign({}, state, {
    entities: {
      ...state.entities,
      doorControllers: {
        byId: {
          ...byId,
          [parentId]: {
            ...parentController,
            expansionIds: parentController.expansionIds.concat(id),
            expansionHeadingCounter: (parentController.expansionHeadingCounter + ACCESS_HEADING_ROTATION_DEGREE) % 360
          },
          [id]: doorController
        },
        allIds: allIds.concat(id)
      },
      wires: {
        byId: wiresById,
        allIds: newWireIds
      }
    },
    currentEntity: {
      type: 'doorController',
      id
    },
    ui: {
      ...state.ui,
      sidebarView: 'doorControllerDetails'
    }
  })
}



// WEBPACK FOOTER //
// ./src/reducers/addExpansionController.js